import { ThemeProvider } from '@mui/material/styles';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import GlobalStylesCss from './components/layout/GlobalStyles';
import theme from './components/theme';
import routes from './store/routes';

const AppRoute = () => {
  const routing = useRoutes(routes);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStylesCss />
      {routing}
    </ThemeProvider>
  );
}
const App = () => {
  return (
    <Router>
      <AppRoute />
    </Router>
  );
};


export default App;
